/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useRef, useState } from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import WithLocalSvg from '@web-components/common/WithLocalSvg';
import ImageCrop from '@web-components/common/ImageCrop/ImageCrop';
import { isWeb } from '~global/screens';
import { Modalize } from 'react-native-modalize';

const dismissSource = require('~assets/img/common/modal-dismiss.svg');

const EgiftCropPhoto = (props) => {
  const dispatch = useDispatch();
  const modalizeRef = useRef(null);
  const [isCloseCropper, setCloseCropper] = useState(false);

  const isShow = useSelector((state) => state.modal.egiftCropPhoto.isShow);
  const modalCropPhotoData = useSelector(
    (state) => state.modal.egiftCropPhoto.data,
  );

  useEffect(() => {
    if (isShow) {
      modalizeRef.current?.open();
      setCloseCropper(false);
    } else {
      modalizeRef.current?.close();
    }
  }, [isShow]);
  const closeModal = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'egiftCropPhoto' });
    setCloseCropper(true);
  };

  return (
    <Modalize
      ref={modalizeRef}
      adjustToContentHeight={true}
      closeOnOverlayTap={false}
      withInsetsBottom
      modalStyle={styles.modalStyle}>
      <View>
        {isShow ? (
          <View style={styles.modalContainer}>
            <Text style={styles.modalHeaderHeading}>Crop Photo</Text>
            <Pressable style={styles.modalDismiss} onPress={closeModal}>
              <WithLocalSvg
                key="dismiss"
                width={14}
                height={14}
                asset={dismissSource}
              />
            </Pressable>
          </View>
        ) : (
          false
        )}

        <ImageCrop
          imageSource={modalCropPhotoData}
          enabledSlider={true}
          isCloseCropper={isCloseCropper}
          sliderText="Atur posisi re foto"
          cropperConfig={{
            dragMode: 'move',
            zoomable: true,
            restore: false,
            guides: true,
            center: false,
            highlight: false,
            cropBoxMovable: true,
            cropBoxResizable: true,
            toggleDragModeOnDblclick: false,
            autoCropArea: 1,
            aspectRatio: 1.91,
            viewMode: 3,
          }}
        />
      </View>
    </Modalize>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    paddingBottom: 24,
    paddingTop: 20,
    paddingHorizontal: 16,
    marginBottom: 16,
    justifyContent: 'space-between',
  },

  modalStyle: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    ...(isWeb
      ? {
          width: 600,
          margin: 'auto',
          borderRadius: 8,
        }
      : {}),
    paddingHorizontal: 0,
  },

  modalDismiss: {
    ...(isWeb && { cursor: 'pointer' }),
    position: 'absolute',
    right: 25,
  },
  modalHeaderHeading: {
    fontFamily: 'satoshi-black',
    fontSize: 17,
    lineHeight: 23,
    color: '#404040',
  },
});

export default EgiftCropPhoto;
